/* eslint-disable */
<template>
  <div class="join-right">
    <div class="big-title">
      <ego-title :title="'学员权益'" :subtitle="''" class=""></ego-title>
    </div>
    <!-- <div class="tab" v-if="!isMobile">
      <h3 :class="activeTab === i ? 'active' : ''" v-for="(titleItem, i) in title" :key="i" @click="changeTab(i)">{{titleItem}}</h3>
    </div> -->
    <div class="container" v-if="!isMobile">
      <div class="right-wrap" v-for="(item, i) in joinRight" :key="i">
        <div class="right-list">
          <div class="item">
            <div class="img">
              <img style="height: 100%" :src="item.imgUrl" alt="">
            </div>
            <h3 style="white-space: pre-wrap">{{item.title}}</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-else>
      <div class="right-wrap"  v-for="(item, i) in joinRight" :key="i">
        <div class="right-list">
          <div class="item">
            <div class="img">
              <img style="height: 100%" :src="item.imgUrl" alt="">
            </div>
            <h3 style="white-space: pre-wrap">{{item.title}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import egoTitle from '@/base/ego-title'
export default {
  data () {
    return {
      activeTab: 0
    }
  },
  components: {
    egoTitle
  },
  props: ['isMobile'],
  computed: {
    // title () {
    //   return ['标准学员权益', '企业学员权益']
    // },
    joinRight () {
      return [
        {
          imgUrl: require('./assets/person/1.png'),
          title: '同侪小组·共同成长'
        },
        {
          imgUrl: require('./assets/person/2.png'),
          title: '月度学习·丰富活动'
        },
        {
          imgUrl: require('./assets/person/17.png'),
          title: '年度家宴·休闲社交'
        },
        {
          imgUrl: require('./assets/person/3.png'),
          title: '社交晚宴·扩大人脉'
        },
        {
          imgUrl: require('./assets/person/4.png'),
          title: '线上社群·链接全球'
        },
        {
          imgUrl: require('./assets/person/5.png'),
          title: '行业小组·认知升级'
        },
        {
          imgUrl: require('./assets/person/18.png'),
          title: '兴趣小组·全球同频'
        },
        {
          imgUrl: require('./assets/person/8.png'),
          title: '每日资讯·速览新事'
        },
        {
          imgUrl: require('./assets/person/9.png'),
          title: '权威报告·精编推送'
        },
        {
          imgUrl: require('./assets/person/19.png'),
          title: '企业图谱·高效对接'
        },
        {
          imgUrl: require('./assets/person/20.png'),
          title: '企业走访·多维链接'
        },
        {
          imgUrl: require('./assets/person/11.png'),
          title: '专属平台·信息发布'
        },
        {
          imgUrl: require('./assets/person/21.png'),
          title: '高手对话·思维碰撞'
        },
        {
          imgUrl: require('./assets/person/22.png'),
          title: '整合营销·独家折扣'
        },
        {
          imgUrl: require('./assets/person/23.png'),
          title: '技术大会·专属折扣'
        },
        {
          imgUrl: require('./assets/person/24.png'),
          title: 'GTLC全球总站·全球团聚'
        },
        {
          imgUrl: require('./assets/person/25.png'),
          title: '超级会员·在线学习'
        },
        {
          imgUrl: require('./assets/person/26.png'),
          title: '极客时间企业版·提升员工能力'
        }
      ]
    }
  },
  methods: {
    // changeTab (i) {
    //   this.activeTab = i
    // }
  }
}
</script>
<style scoped lang='sass'>
@import '../../../style/bulma/app.sass'
.join-right
  width: 90vw
  // height: 53vw
  // display: flex
  margin: 0 auto
  +mobile
    width: 100vw
    // height: 240vw
  img
    vertical-align: middle
  .big-title
    padding-top: 70px
    margin-bottom: 88px
    +mobile
      margin-bottom: 20px
  .tab
    display: flex
    justify-content: space-around
    width: 80%
    margin: 0 auto
    font-size: 34px
    h3
      position: relative
      color: #B2B2B2
      cursor: pointer
    h3.active
      color: #333
    h3.active:before
      content: ''
      position: absolute
      bottom: -5px
      left: 50%
      margin-left: -15px
      border-radius: 3px
      width: 30px
      height: 6px
      background: #f66644
  .container
    display: flex
    flex-wrap: wrap
    justify-content: space-around
    width: 1220px
    max-width: 1220px
    // padding-top: 90px
    +mobile
      padding-top: 34px
      width: 100%
      max-width: 100%
      .small-title
        margin-bottom: 30px
    .right-wrap
      width: 190px
      height: 182px
      // display: none
      +mobile
        width: 130px
        height: 100px
        margin-bottom: 20px
      &.active
        display: block
    .right-title
      margin-bottom: 50px
      +mobile
        margin-bottom: 25px
    .right-list
      // display: flex
      // flex-wrap: wrap
      .item
        // width: 16%
        font-size: 18px
        text-align: center
        margin-bottom: 70px
        padding: 0 26px
        box-sizing: border-box
        +mobile
          // width: 50%
          margin-bottom: 25px
          font-size: 11px
          padding: 0 20px
          &:nth-child(5)
            padding: 0 43px
          &:nth-child(9)
            padding: 0 43px
        .img
          height: 65px
          display: flex
          align-items: center
          justify-content: center
          margin-bottom: 20px
          +mobile
            height: 14vw
            margin-bottom: 10px
        h3, p
          font-size: 18px
          +mobile
            font-size: 11px
        h3
          color: #353535
          font-weight: bold
          margin-bottom: 5px
          width: 124%
          margin-left: -12%
        p
          color: #888888
      .item:last-child
        padding: 0 20px
      .item:nth-child(5) .img, .item:last-child .img
        // width: 50px
        +mobile
          // width: 12vw

</style>
